<template>
	<div>
		<!-- <div class="spinner-border" v-if="loader" style="margin:auto;display:block;margin-top:60px"/> -->
		<form v-on:submit.prevent class="main_form_block">
			<div style = "border:1px #e2e2e2 solid; padding:20px" class = "col-sm-11">
							<div class="form-group row">
							<label class="col-sm-3 col-form-label">
								ASIN<sup>*</sup>
							</label>
							<div class="col-sm-7 pr-5">
								<!-- <multiselect
									v-model="asinList"
									:options="asinOptions"
									:multiple="true"
									:taggable="true"
									label="asin"
									track-by="id"
									@tag="addAsin($event)"
									placeholder="Add Asins"
									tag-placeholder="Add this as new Asin"
									class="form-control multi-dropdown"
									selectLabel = ""
									deselectLabel = ""
									>
								</multiselect> -->
								<input
									type="text"
									name="entityId"
									v-model="asinData.asin"
									class="form-control"
									id="entityId"
									placeholder="ASIN"
									autocomplete = "off"
								>
								<span
								  v-if="validated && (asinData && asinData.asin == '')"
								  class="no-data-style"
							  >This field is required</span>
							</div>
						</div>

						<div class="form-group row">
							<label class="col-sm-3 col-form-label">
								Product Title<sup>*</sup>
							</label>
							<div class="col-sm-7 pr-5">
								<input
									type="text"
									name="entityId"
									v-model="asinData.product_title"
									class="form-control"
									id="entityId"
									placeholder="Product title"
									autocomplete = "off"
								>
								<span
								  v-if="validated && (asinData && asinData.product_title == '')"
								   class="no-data-style"
							  >This field is required</span>
							</div>
						</div>

						<div class="form-group row">
							<label class="col-sm-3 col-form-label">
								Brand Code<sup>*</sup>
							</label>
							<div class="col-sm-7 pr-5">
								<input
									type="text"
									name="entityId"
									v-model="asinData.brand_code"
									class="form-control"
									id="entityId"
									placeholder="Brand code"
									autocomplete = "off"
								>
								<span
								  v-if="validated && (asinData && asinData.brand_code == '')"
								   class="no-data-style"
							  >This field is required</span>
							</div>
						</div>

						<div class="form-group row">
							<label class="col-sm-3 col-form-label">
								Vendor Name<sup>*</sup>
							</label>
							<div class="col-sm-7 pr-5">
								<multiselect
									v-model="vendorData"
									:options="vendorList"
									label="name"
									:searchable="true"
									ref="multiselect"
									track-by="name"
									open-direction="bottom"
									placeholder="Vendor"
									class="form-control multi-dropdown select_filter"
									@select = "getBrands($event)"
									selectLabel
									deselectLabel
									selectedLabel
									tagPlaceholder="Select Vendor"
									autocomplete="off"
									style="max-height:40px;"
									:multiple="false"
									id="vendor"
								/>
								<span
								  v-if="validated && !vendorData"
								  class="no-data-style"
							  >This field is required</span>
							</div>

						</div>

						<div class="form-group row">
							<label class="col-sm-3 col-form-label">
								Brand Name<sup>*</sup>
							</label>
							<div class="col-sm-7 pr-5" v-if = "!showBrandLoader">
								<multiselect
									v-model="brandData"
									:options="brandList"
									label="name"
									:searchable="true"
									ref="multiselect"
									track-by="name"
									open-direction="bottom"
									placeholder="Brand"
									class="form-control multi-dropdown select_filter"
									selectLabel
									deselectLabel
									selectedLabel
									tagPlaceholder="Select Brand"
									autocomplete="off"
									style="max-height:40px;"
									:multiple="false"
									id="vendor"
								/>
								<span
								  v-if="validated && !brandData"
								  class="no-data-style"
							  >This field is required</span>
							</div>
							<div class="spinner-border" style="" v-else/>



						</div>

						<!-- <div class="form-group row">
							<label class="col-sm-3 col-form-label">
								Responsible Contact
							</label>
							<div class="col-sm-7 pr-5">
								<input
									type="text"
									name="entityId"
									v-model="asinData.responsible_contact"
									class="form-control"
									id="entityId"
									placeholder="Enter responsible contact"
									autocomplete = "off"
								>
							</div>
						</div> -->


						<div class="form-group row">
							<label class="col-sm-3 col-form-label">
								Country Code<sup>*</sup>
							</label>
							<div class="col-sm-7 pr-5">
								<input
									type="text"
									name="entityId"
									v-model="asinData.country_code"
									class="form-control"
									id="entityId"
									placeholder="Country Code"
									autocomplete = "off"
								>
								<span
								  v-if="validated && (asinData && asinData.country_code == '')"
								    class="no-data-style"
							  >This field is required</span>
							</div>
						</div>

						<div class="form-group row">
							<label class="col-sm-3 col-form-label">
								PDP URL<sup>*</sup>
							</label>
							<div class="col-sm-7 pr-5">
								<input
									type="text"
									name="entityId"
									v-model="asinData.pdp_url"
									class="form-control"
									id="entityId"
									placeholder="PDP URL"
									autocomplete = "off"
								>
								<span
								  v-if="validated && (asinData && asinData.pdp_url == '')"
								  class="no-data-style"
							  >This field is required</span>
							</div>
						</div>


						<div class="form-group row">
							<button class="btn btn-secondary" @click="navigateToListPage('cancel')">Cancel</button>
							<button class="btn btn-primary" @click="saveAsinData()">Save</button>
						</div>
			</div>



					</form>
	</div>
</template>
<script>
	import multiselect from "vue-multiselect";

	export default {
		name: "AddAsinScraperDetails.vue",
		data() {
			return {
				asinData:{
					asin:"",
					brand_code:"",
					vendor:"",
					brand:"",
					product_title:"",
				//	responsible_contact:"",
					active:true,
					pdp_url:"",
					country_code:"",

				},
				showBrandLoader:false,
				vendorData:null,
				brandData:null,
				validated:false
				//asinOptions:[],
				//asinList:[]
			};
		},
		components: {
			multiselect
		},
		mounted() {
			this.$store.dispatch("callAnalytics", {data:window.location.href, this:this, type:'AddAsinScraper'})

		},
		computed:{
			vendorList(){
				let data = this.$store.state.vendorList.filter(e => e.name);
				return data;
			},
			brandList : {
			    set(val) {
			        this.$store.state.brandProfileList = val;
			      },
			    get() {
					let data = this.$store.state.brandProfileList;
					return data
			      }
			}
		},
		watch: {
		},
		methods: {
			getBrands(data){
				let payload = {
					 vendorId :data.id
				  }
				this.$store.state.brandProfileList = [];
				this.brandList = [];
				this.brandData = []
				this.showBrandLoader = true;
				this.$store.dispatch("getAllBrandProfile",payload).then((resp) => {
					this.showBrandLoader = false;
				})
			},
			navigateToListPage(data){
				if (data == "cancel") {
					this.$store.state.calledFromCancel = true;
				}
				this.$router.push({ path: "/asinScraper" });
			},
			saveAsinData(){
				
				this.validated = true;
				if(this.vendorData){
					this.asinData.vendor = this.vendorData.master_vendor;
				}
				if(this.brandData){
					this.asinData.brand = this.brandData.name
				}
				if(this.isValidated()){
					let vm = this;
					this.$store.dispatch("asinScapper/saveNewAsin", this.asinData).then((res) => {
						vm.$router.push({path:'/asinScraper'})
					})
				}

				// if(this.asinList.length){
				// 	this.asinData.asin = this.asinList
				// }

			},
			isValidated(){

				if(!this.asinData.vendor || !this.asinData.brand || !this.asinData.asin || !this.asinData.brand_code || !this.asinData.product_title || !this.asinData.pdp_url || !this.asinData.country_code){
					return false
				}
				else{
					return true
				}

			},
			addAsin(data){
				data = data.split(',');
				let list = [...this.asinList];
				 data.map((e) => {
					list.push({name:e,asin:e,id:e})
				})
				this.asinOptions = [...list];
				this.asinList = [...list]
			}
		}
	};
</script>

<style lang="scss">
</style>
